const tabs = document.getElementsByClassName('product-tabs-button');
const tabsContent = document.getElementsByClassName('product__tabs-content');

const toggleTabVisibility = (index) => {
  Array.from(tabsContent).forEach((content) => {
    if (index == content.dataset.index) {
      content.style.display = 'block';
    } else {
      content.style.display = 'none';
    }
  });
};
Array.from(tabs).forEach((tab, i) => {
  tab.addEventListener('click', function () {
    if (!this.classList.contains('active')) {
      this.classList.add('active');
      toggleTabVisibility(i);
      if (i === 0) {
        this.nextElementSibling.classList.remove('active');
      } else {
        this.previousElementSibling.classList.remove('active');
      }
    }
  });
});
